import {FormSection} from '@/components/commons/form-section/FormSection'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext} from 'react-hook-form'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Label} from '@/components/ui/label/Label'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {RadioField} from '@/components/commons/radio-field/RadioField'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {ObjectKeys} from '@/utilities/helpers'
import {z} from 'zod'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {periodicityHypothesisMapToLabel} from '../../utils'

const PeriodicityHypothesisSchema = MedicalReportFieldsSchema.pick({
    treatmentsPlan: true,
    objectives: true,
    cyclePeriodicityHypothesis: true
})
type PeriodicityHypothesisSchema = z.infer<typeof PeriodicityHypothesisSchema>

export const PeriodicityHypothesisSectionForm = () => {
    const {t} = useTranslation()
    const form = useFormContext<PeriodicityHypothesisSchema>()

    return (
        <FormSection
            title={t('medical_records:cycle_periodicity_hypothesis')}
            description={t('medical_records:cycle_periodicity_hypothesis_description')}
        >
            <Controller
                control={form.control}
                name="cyclePeriodicityHypothesis"
                render={({field, fieldState}) => (
                    <Flexbox direction="column" gap={1.5} fullWidth>
                        <Label>{t('medical_records:cycles_number')}</Label>
                        <Flexbox fullWidth direction="column" gap={1.5}>
                            <Grid columns={3} gap={4} fullWidth>
                                {ObjectKeys(periodicityHypothesisMapToLabel).map(hypothesisKey => (
                                    <FormFieldBox
                                        key={hypothesisKey}
                                        spanColumn={1}
                                        isSelected={field.value == hypothesisKey}
                                        hasError={!!fieldState.error?.message}
                                    >
                                        <RadioField
                                            label={t(periodicityHypothesisMapToLabel[hypothesisKey])}
                                            name={'cyclePeriodicityHypothesis'}
                                            checked={field.value == hypothesisKey}
                                            onChange={field.onChange}
                                            value={hypothesisKey}
                                        />
                                    </FormFieldBox>
                                ))}
                            </Grid>
                            {fieldState.error?.message && <InputHelpText error={fieldState.error?.message} />}
                        </Flexbox>
                    </Flexbox>
                )}
            />
        </FormSection>
    )
}
